var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUncheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.835 19.67C15.2667 19.67 19.67 15.2667 19.67 9.835C19.67 4.40328 15.2667 0 9.835 0C4.40328 0 0 4.40328 0 9.835C0 15.2667 4.40328 19.67 9.835 19.67Z",
    fill: "#E63946"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8784 9.83498L13.3077 7.40573C13.438 7.2659 13.5089 7.08096 13.5055 6.88987C13.5022 6.69877 13.4247 6.51644 13.2896 6.3813C13.1544 6.24615 12.9721 6.16874 12.781 6.16537C12.5899 6.162 12.405 6.23293 12.2652 6.36322L9.83591 8.79247L7.40667 6.36322C7.26684 6.23293 7.0819 6.162 6.8908 6.16537C6.69971 6.16874 6.51738 6.24615 6.38223 6.3813C6.24709 6.51644 6.16967 6.69877 6.1663 6.88987C6.16293 7.08096 6.23386 7.2659 6.36416 7.40573L8.7934 9.83498L6.36416 12.2642C6.22603 12.4025 6.14844 12.59 6.14844 12.7855C6.14844 12.9809 6.22603 13.1684 6.36416 13.3067C6.50246 13.4449 6.68994 13.5225 6.88541 13.5225C7.08088 13.5225 7.26836 13.4449 7.40667 13.3067L9.83591 10.8775L12.2652 13.3067C12.4035 13.4449 12.5909 13.5225 12.7864 13.5225C12.9819 13.5225 13.1694 13.4449 13.3077 13.3067C13.4458 13.1684 13.5234 12.9809 13.5234 12.7855C13.5234 12.59 13.4458 12.4025 13.3077 12.2642L10.8784 9.83498Z",
    fill: "#EDEBEA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUncheck);
export default __webpack_public_path__ + "static/media/uncheck.70c39ba09efdfeaf4f597594518a78b4.svg";
export { ForwardRef as ReactComponent };